// Label — form label per COMPONENTS §Input + §Per-primitive WCAG.
//
// `htmlFor` always required (TypeScript-enforced). Required-asterisk is
// aria-hidden — the underlying Input's `required={true}` is the programmatic
// signal per WCAG 2.2 SC 1.3.1 + SC 3.3.2.

import type { LabelHTMLAttributes, ReactNode } from 'react';

export interface LabelProps extends Omit<LabelHTMLAttributes<HTMLLabelElement>, 'htmlFor'> {
  htmlFor: string;
  required?: boolean;
  children: ReactNode;
}

export function Label({ htmlFor, required = false, className = '', children, ...props }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-medium text-[var(--color-text-primary)] mb-1 ${className}`}
      {...props}
    >
      {children}
      {required && (
        <span aria-hidden="true" className="text-[var(--color-danger)] ms-0.5">
          *
        </span>
      )}
    </label>
  );
}
